import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { AppState } from '../../app.state';
import { initSearchState, updateSearchState } from '../../player.actions';
import { selectSearchStateSelector } from '../../player.selectors';

@Component({
  selector: 'search-component',
  standalone: true,
  imports: [MatIconModule, FormsModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements OnInit {
  private readonly store = inject(Store<AppState>);
  private readonly router = inject(Router);

  protected readonly text = toSignal(
    this.store.select(selectSearchStateSelector).pipe(map((s) => s.searchText)),
    { initialValue: '' },
  );

  ngOnInit(): void {
    this.store.dispatch(initSearchState());
  }

  /**
   * Search is global: typing anywhere sends you to the full station list,
   * which is the view that knows how to filter. Inside a category the query
   * narrows that category instead.
   */
  protected search(value: string): void {
    this.store.dispatch(updateSearchState({ searchText: value }));
    if (value && !this.router.url.startsWith('/radios/')) {
      this.router.navigate(['/radios', 'all']);
    }
  }

  protected clear(): void {
    this.store.dispatch(updateSearchState({ searchText: '' }));
  }
}
